import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function Slots({ slots, titleClassnames, descriptionClassnames }) {
	const { t } = useTranslation();
	return (
		<>
			<dt className={`${titleClassnames} text-primary-color`}>{t('trainings.slots')}</dt>
			<dd className={descriptionClassnames} style={{ minHeight: 24 }}>
				{slots.map((slot) => (
					<div key={slot.id}>{slot.start}</div>
				))}
			</dd>
		</>
	);
}

Slots.propTypes = {
	slots: PropTypes.array.isRequired,
	titleClassnames: PropTypes.string.isRequired,
	descriptionClassnames: PropTypes.string.isRequired,
};

export default Slots;
